var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"px-2 px-md-5 py-2 tag",class:[
    { 'tag-active': _vm.props.isActive },
    ("tag-" + (_vm.props.variant)),
    _vm.props.extraCssClass
  ],on:{"click":function($event){return _vm.props.onClick(_vm.props.label)}}},[_vm._v("\n  "+_vm._s(_vm.props.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }